export default "__VITE_ASSET__C9IY9cDf__"